import Channel2Img from './images/illuchannel2.svg'
import Channel3Img from './images/illuchannel3.svg'
import Channel4Img from './images/illuchannel4.svg'

export const templateChannels = [
  {
    name: 'Employee onboarding',
    token: 'PqMhMJjTy9MJyygRuuRcPX',
    image: Channel2Img,
  },
  {
    name: 'Product specs',
    token: 'XRYz1zUKTnBA6Pah5Fa44X',
    image: Channel4Img,
  },
  {
    name: 'Team meetings',
    token: 'FdPwZ1eg9f7WrS6zi9RSoW',
    image: Channel3Img,
  },
]
